import React from 'react';
class Project extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement("a", { href: this.props.link, className: "project col-sm-3" },
            React.createElement("article", { className: "row" },
                React.createElement("header", null,
                    React.createElement("img", { src: this.props.imageUrl, className: "col-sm-12", alt: this.props.name })),
                React.createElement("section", null,
                    React.createElement("p", null,
                        "Projekt: ",
                        this.props.name),
                    React.createElement("p", null, this.props.description)))));
    }
}
export default Project;
